import React from "react";
import {
  TableManger,
  TABLES,
  TABLE_DISPLAY_NAME,
} from "../../../managers/TableManger";
import {
  DOCUMENT_STATUS,
  getDocumentColumnConfig,
  getFileName,
  parseColumnConfig,
  parseVisibleColumnConfig,
} from "../../configs/config";
import { deepClone } from "../../../utility/Utility";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import ReportService from "../../../services/ReportService";
import moment from "moment";
import { saveAs } from "file-saver";
import {
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
    DKIcons,
    showAlert,
    DKLabel,
    DKButton
} from "deskera-ui-library";
import FileUpload from "../../common/FileUpload";
import AttachmentService, { Entity } from "../../../services/AttachmentService";
import { DOCUMENT_STATUS_MAP } from "../../../constants/Constant";
import { STEP_NAME } from "../../common/Dashboard/SetupDetails";
import FillingAuthorization from "../../compliance/us/FillingAuthorization";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import { isUSStateComplianceEnabled } from "../../compliance/us/ConstantsUS";
import { MODULE } from "../../user-permissions/PermissionUtils";
import i18next from "i18next";
class Documents extends React.Component {
  documentColumns = [];

  constructor(props) {
    super(props);

    this.documentColumns = parseVisibleColumnConfig(
      parseColumnConfig(
        TableManger.getTableVisibleColumns(TABLES.PEOPLE_DOCUMENT)
      )
    );

    this.state = {
      reload: false,
      documents: {
        columnData: deepClone(this.documentColumns),
        rowData: [],
        filter: [],
        originalData: [],
      },
      pagination: {
        currentPage: 0,
        totalPageCount: 0,
      },
      uploadConfig: {
        showUpload: false,
        rowData: null,
        isSigned: false,
        rowIndex: 0,
        isUploadAndReplace: false,
        readAndAccept: false
      },
      userDocuments: this.props.employeeData?.documents,
      showFilingAuth:false,
      filingAuthStyle: {
        width:'65vw',
        height: '80vh'
      }
    };
  }

  componentDidMount() {
    this.loadDocuments(this.state.pagination);

    this.props.setData({
      defaults: {
        documents: this.state.userDocuments,
      },
    });
  }

  loadDocuments(config) {
    const functionConfig = this.getFunctionConfig();
    const rowData = getDocumentColumnConfig(
      this.props.userId,
      this.state.userDocuments,
      functionConfig
    );

    const documents = {
      columnData: deepClone(this.documentColumns),
      rowData: rowData,
      filter: [],
      originalData: rowData,
    };

    this.setState({
      documents: documents,
      pagination: {
        currentPage: config.currentPage,
        totalPageCount: config.totalPageCount,
      },
    });
  }

  getFunctionConfig() {
    let config = {
      uploadSigned: this.onDocumentUpload,
      downloadSigned: this.onDocumentDownload,
      uploadAndReplace: this.onDocumentUploadAndReplace,
      deleteDocument: this.onDocumentDelete,
      readAndAccept: this.onReadAndAccept,
    };
    return config;
  }

  onDocumentUploadAndReplace = (data, isSigned, isDocumentUploadAndReplace) => {
    this.onDocumentUpload(data, isSigned, isDocumentUploadAndReplace);
  };

  onDocumentDelete = (data, isSigned) => {
    const rowIndex = data ? data.rowIndex : 0;
    const userDocuments = deepClone(this.state.userDocuments) || [];
    userDocuments.splice(rowIndex, 1);
    this.setState(
      {
        userDocuments: userDocuments,
      },
      () => {
        this.loadDocuments(this.state.pagination);

        this.props.setData({
          defaults: {
            documents: userDocuments,
          },
        });

        this.resetUploadConfig();
      }
    );
  };

  onReadAndAccept = (data) => {
    this.setState({
      uploadConfig: {
        showUpload: false,
        rowData: data?.rowData,
        isSigned: false,
        rowIndex: data?.rowIndex,
        isUploadAndReplace: false,
        readAndAccept: true
      },
    }, this.updateUserDocument);
  }

  onDocumentDownload = (data, isSigned) => {
    if (isSigned) {
      if (data.rowData.path) {
        this.downloadDocument(data.rowData.path);
      } else {
        showToast("Document is not available to download.", TOAST_TYPE.FAILURE);
      }
    } else {
      if (data.rowData.status === DOCUMENT_STATUS.INCOMPLETE) {
        showToast(
          "Incomplete profile information. Please fill all the required fields and then try.",
          TOAST_TYPE.FAILURE
        );
      } else {
        switch (data.rowData.key) {
          case "I9":
            this.downloadI9Form("I9");
            break;
          case "W4":
            this.downloadW4Form("FORMW4");
            break;
          default:
            this.downloadDocument(data.rowData.path);
        }
      }
    }
  };

  downloadDocument = (path) => {
    showLoader("Downloading document... Please wait");
    AttachmentService.getPresignedURL(path).then(
      (response) => {
        AttachmentService.downloadFile(response).then(
          (response) => {
            removeLoader();
            saveAs(response, getFileName(path));
          },
          (error) => {
            removeLoader();
          }
        );
      },
      (error) => {
        removeLoader();
      }
    );
  };

  downloadI9Form(key) {
    showLoader("Downloading document... Please wait");

    ReportService.apiConfig = {
      year: moment().year(),
    };

    ReportService.downloadForm([this.props.userId], key, {}).then(
      (response) => {
        removeLoader();
        const fileName = `${this.props.employeeData?.firstName}_${this.props.employeeData?.lastName}_${key}.pdf`;
        saveAs(response, fileName);
      },
      (error) => {
        removeLoader();
        showToast("Internal Server Error", TOAST_TYPE.FAILURE);
      }
    );
  }

  downloadW4Form(key) {
    showLoader("Downloading document... Please wait");

    const params = {
      userId: this.props.userId,
      year: moment().year(),
    };

    ReportService.downloadStateForm(key, params).then(
      (response) => {
        removeLoader();
        const fileName = `${this.props.employeeData?.firstName}_${this.props.employeeData?.lastName}_${key}.pdf`;
        saveAs(response, fileName);
      },
      (error) => {
        removeLoader();
        showToast("Internal Server Error", TOAST_TYPE.FAILURE);
      }
    );
  }

  onDocumentUpload = (data, isSigned, isDocumentUploadAndreplace) => {
    if (data && data.rowData.status === DOCUMENT_STATUS_MAP.INCOMPLETE) {
      showToast(
        "Incomplete profile information. Please fill all the required fields and then try.",
        TOAST_TYPE.FAILURE
      );
    } else {
      this.setState({
        uploadConfig: {
          showUpload: true,
          rowData: data?.rowData,
          isSigned: isSigned,
          rowIndex: data?.rowIndex,
          isUploadAndReplace: isDocumentUploadAndreplace,
        },
      });
    }
  };

  updateUserDocument = (path, fileInfo) => {
    const userDocuments = deepClone(this.state.userDocuments) || [];

    if (this.state.uploadConfig.isSigned) {
      userDocuments.forEach((d) => {
        if (d.key === this.state.uploadConfig.rowData.key) {
          d.path = path;
          d.status = "SIGNED";
        }
      });
    } else if (this.state.uploadConfig.isUploadAndReplace) {
        let documentIndex = this.state.uploadConfig.rowIndex;
        userDocuments.splice(documentIndex, 1);
        userDocuments.push(UserDocument(fileInfo.name, path, parseInt(TenantService.get(TENANT.IAM_USER_ID))));
    } else if (this.state.uploadConfig.readAndAccept) {
      userDocuments.forEach((d) => {
        if (d.key === this.state.uploadConfig.rowData.key) {
          d.status = "READ_AND_ACCEPT";
          d.uploadedOn = moment();
        }
      });
    } else {
      userDocuments.push(UserDocument(fileInfo.name, path, parseInt(TenantService.get(TENANT.IAM_USER_ID))));
    }

    this.setState(
      {
        userDocuments: userDocuments,
      },
      () => {
        this.loadDocuments(this.state.pagination);

        this.props.setData({
          defaults: {
            documents: userDocuments,
          },
        });

        this.resetUploadConfig();
      }
    );
  };

  resetUploadConfig() {
    this.setState({
      uploadConfig: {
        showUpload: false,
        rowData: null,
        isSigned: false,
        rowIndex: 0,
        isUploadAndReplace: false,
      },
    });
  }

  uploadDocument(files) {
    if (files && files[0]) {
      showLoader("Uploading files... Please wait");
      AttachmentService.getUploadFileURL(
        files[0].fileContent,
        Entity.PEOPLE_DOCUMENT
      ).then(
        (response) => {
          removeLoader();
          this.updateUserDocument(response.relativePath, files[0].fileInfo);
        },
        (error) => {
          if(error?.status === 500 && error?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
            showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
            removeLoader();
          } else {
            showToast(i18next.t('SOMETHING_WENT_WRONG'), TOAST_TYPE.FAILURE);
            removeLoader();
          }
        }
      );
    }
  }

  showUploadPopup() {
    return (
      <FileUpload
        isMultiSelect={false}
        onSave={(files) => {
          this.uploadDocument(files);
        }}
        onClose={() => {
          this.resetUploadConfig();
        }}
      />
    );
  }
  renderHeader = () => {
    return (
        <div className="row justify-content-between p-h-xxl p-v-m bg-gray2">
            <DKLabel text={STEP_NAME.filingAuthorization} className="fs-l fw-m" />
            <DKButton icon={DKIcons.ic_close} onClick={()=>{
              this.toggleFilingAuthPopup();
            }} />
        </div>
    )
}

  showFilingAuthPopup() {
    return (
      <div className="transparent-background">
        <div className="popup-window" style={{ padding: 0, minWidth: this.state.filingAuthStyle.width, maxWidth: this.state.filingAuthStyle.width, minHeight: this.state.filingAuthStyle.height, maxHeight: this.state.filingAuthStyle.height, overflow: "hidden" }}>
          
          <div className="parent-width custom-scroll" style={{ minHeight: `calc(${this.state.filingAuthStyle.height} - 56px)`, maxHeight: `calc(${this.state.filingAuthStyle.height} - 56px)`, overflow: "auto" }}>
            <FillingAuthorization
              {...this.props}
              renderAsStep={true}
              isDocument={true}
              onClose={() => {
                this.setState((prevState)=>({
                  showFilingAuth: false
                }))
              }}
              onSaveAndNext={() => {
              }}
            />
          </div>
        </div>
      </div>
    )
  }
  toggleFilingAuthPopup() {
    this.setState((prevState)=>({
      showFilingAuth: !prevState.showFilingAuth
    }))
  }
  getGridHeaderButton() {
    const filingAuthButton = {
      title: STEP_NAME.filingAuthorization,
      icon:DKIcons.ic_document,
      className: "bg-gray1 border-m mr-m",
      onClick: () => {
        this.toggleFilingAuthPopup()
      }
    }
    let buttons = [
      {
        title: "+ Upload Document",
        className: "bg-app text-white",
        onClick: () => {
          this.onDocumentUpload(null, false, false);
        },
      }
    ];
    if(!TenantService.get(TENANT.IS_ADMIN) && isUSStateComplianceEnabled(TenantService.get(TENANT.STATE_CODE))) {
      buttons.push(filingAuthButton);
    }
    return buttons
  }

  render() {
    return (
      <div
        className="column parent-width flex-1 parent-height"
        style={{ minHeight: 250 }}
      >
        <div className="column parent-width mb-s position-relative flex-1 ">
          <DataGridHolderPayroll
            tableName={TABLES.PEOPLE_DOCUMENT}
            displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_DOCUMENT]}
            allowColumnEdit={false}
            allowColumnDelete={false}
            allowColumnShift={false}
            allowSearch={false}
            allowFilter={false}
            onRowDelete={() => {}}
            onRowEdit={() => {}}
            allowRowAdd={true}
            addButtonConfig={this.getGridHeaderButton()}
            allowRowEdit={false}
            allowDataExport={false}
            gridData={this.state.documents}
            onSearch={() => {}}
            onColumnAdd={() => {}}
            onFilter={() => {}}
            filter={this.state.documents.filter}
            onRowAdd={() => {}}
            onPaginationClick={(requestedPageNumber) => {
              const config = {
                ...this.state.pagination,
                currentPage: requestedPageNumber,
              };
              this.loadDocuments(config);
            }}
            currentPage={this.state.pagination.currentPage}
            totalPageCount={this.state.pagination.totalPageCount}
            isActionEnabled={true}
            contextMenu={false}
            onStatusChange={() => {}}
            isMenuVisible={false}
            onRowUpdate={() => {}}
            onDocumentDownloadSigned={(data, isSigned) => {
              this.onDocumentDownload(data, isSigned);
            }}
            module={MODULE.EMPLOYEE}
            // onDocumentUploadSigned={(data, isSigned) => {
            //   this.onDocumentUpload(data, true,false);
            // }}
            // onDocumentDelete={(data, isSigned) => {
            //   this.onDocumentDelete(data, isSigned);
            // }}
            // onDocumentUploadAndReplace={(data, isSigned) => {
            //   this.onDocumentUploadAndReplace(data, isSigned, true);
            // }}
          />
          {this.state.uploadConfig.showUpload && this.showUploadPopup()}
          {this.state.showFilingAuth && this.showFilingAuthPopup()}
        </div>
      </div>
    );
  }
}

export default Documents;

function UserDocument(name, path, owner) {
    return {
        key: String(name).concat("_", new Date().getTime()),
        name: name,
        status: "UPLOADED_DOCUMENT",
        path: path,
        uploadedOn: moment(),
        signConfig: {
            isAgree: false,
            font: "",
            sign: ""
        },
        owner: owner,
        isDefault: false,
        isTranslatorUsed: false,
        translatorConfig: {
            isAgree: false,
            firstName: "",
            lastName: "",
            email: "",
            address: {
                addressLine1: "",
                addressLine2: "",
                zipCode: "",
                city: "",
                state: "",
                country: "",
                suburb: "",
                county: ""
            }
        }
    }
}
